import React from "react";
import t from "i18n";

const PaperFilterInscriptionsCA = ({ activeTab, onActiveTabChange }) => {
  return (
    <div style={{ display: "flex", gap: 20 }}>
      <span
        style={{
          cursor: "pointer",
          fontWeight: activeTab === "inscriptions" ? "bold" : "normal",
          borderBottom: activeTab === "inscriptions" ? "3px solid #29394D" : "3px solid #ccc",
          color: activeTab === "inscriptions" ? "#29394D" : "#555",
          paddingBottom: 5,
          width: "100%",
          textAlign: "center",
        }}
        onClick={() => onActiveTabChange("inscriptions")}
      >
        {t('Inscriptions')}
      </span>
      <span
        style={{
          cursor: "pointer",
          fontWeight: activeTab === "chiffreAffaire" ? "bold" : "normal",
          borderBottom: activeTab === "chiffreAffaire" ? "3px solid #29394D" : "3px solid #ccc",
          color: activeTab === "chiffreAffaire" ? "#29394D" : "#555",
          paddingBottom: 5,
          width: "100%",
          textAlign: "center",
        }}
        onClick={() => onActiveTabChange("chiffreAffaire")}
      >
        C.A
      </span>
    </div>
  );
};

export default PaperFilterInscriptionsCA;


// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/PaperFilterInscriptionsCA.js